// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `label {
  width: 100%;
  display: flex;
  align-items: center;
}
label.disabled {
  cursor: default;
}
label.disabled .icon, label.disabled .text, label.disabled i::before {
  color: #B6B5C5;
}

input {
  display: none;
}

i {
  font-size: 1.8rem;
  margin-right: 1rem;
  cursor: pointer;
}

.text {
  font-size: 1.4rem;
  line-height: 1.7rem;
  display: flex;
  align-items: center;
  gap: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/shared/checkbox/checkbox.component.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,aAAA;EACA,mBAAA;AACF;AACE;EACE,eAAA;AACJ;AACI;EAGE,cAAA;AADN;;AAMA;EACE,aAAA;AAHF;;AAMA;EACE,iBAAA;EACA,kBAAA;EACA,eAAA;AAHF;;AAMA;EACE,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;AAHF","sourcesContent":["label {\n  width: 100%;\n  display: flex;\n  align-items: center;\n\n  &.disabled {\n    cursor: default;\n\n    & .icon,\n    & .text,\n    & i::before {\n      color: #B6B5C5; //var(--light-grey) !important;\n    }\n  }\n}\n\ninput {\n  display: none;\n}\n\ni {\n  font-size: 1.8rem;\n  margin-right: 1rem;\n  cursor: pointer;\n}\n\n.text {\n  font-size: 1.4rem;\n  line-height: 1.7rem;\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
